import defaultAttributes from '../defaultAttributes';

const ChevronsLeftRight = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm9 7-5 5 5 5' }],
    ['path', { d: 'm15 7 5 5-5 5' }],
  ],
];

export default ChevronsLeftRight;
